export default [
	{ id: "clicks", name: "resources.unlocks.actions.clicks" },
	{ id: "telegram", name: "resources.unlocks.actions.telegram" },
	// {
	// 	id: "instagram_comments",
	// 	name: "resources.unlocks.actions.instagram_comments",
	// },
];
